import React from 'react';
import { Flex } from '@chakra-ui/react';

import AvailableJournals from '../TransferNetwork/AvailableJournals';

const TransferSettingsTab: React.FC = () => {
  return (
    <Flex flexDirection="column" gap={6} width={"100%"}>
      <AvailableJournals />
    </Flex>
  );
};

export default React.memo(TransferSettingsTab);
